export const submitPaymentForm = (data)=>{
    const form = document.createElement("form");
    form.method = "POST";
    form.action = data.paymentUrl;

    const encRequestInput = document.createElement("input");
    encRequestInput.type = "hidden";
    encRequestInput.name = "encRequest";
    encRequestInput.value = data.encRequest;
    form.appendChild(encRequestInput);

    const accessCodeInput = document.createElement("input");
    accessCodeInput.type = "hidden";
    accessCodeInput.name = "access_code";
    accessCodeInput.value = data.accessCode;
    form.appendChild(accessCodeInput);

    document.body.appendChild(form);
    form.submit();
  }